/* mobile navigation tabs */
import { ResponsiveUtilities } from './utils';
const footer = () => {
  jQuery('.footer-nav-title').on('click', function (e) {
    ResponsiveUtilities.onDeviceType('mobile', function () {
      if (jQuery(this).hasClass('footer-nav-tab-opened')) {
        jQuery(this).parent().find('.footer-nav li a').attr('tabindex', -1);
        jQuery(this).removeClass('footer-nav-tab-opened');
        jQuery(this).attr('aria-expanded', 'false');
      } else {
        jQuery('.footer-nav-title').removeClass('footer-nav-tab-opened');
        jQuery('.footer-nav li a').attr('tabindex', -1);
        jQuery(this).addClass('footer-nav-tab-opened');
        jQuery(this).attr('aria-expanded', 'true');
        if (jQuery('.footer-nav-title').hasClass('footer-nav-tab-opened')) {
          jQuery(this).parent().find('.footer-nav li a').attr('tabindex', 0);
        }
      }
    }, this, e);
  });

  jQuery(window).on('breakpointChanged', function (e) {
    const $navFooterTitleLogo = jQuery('.footer-nav-title-logo');
    if (jQuery('.footer-nav-title').hasClass('footer-nav-tab-opened')) {
      jQuery('.footer-nav-title').removeClass('footer-nav-tab-opened');
    }
    $navFooterTitleLogo.removeAttr('aria-expanded aria-haspopup tabindex role');
    $navFooterTitleLogo.off('keypress');
    ResponsiveUtilities.onDeviceType('mobile', function () {
      $navFooterTitleLogo.find('a').on('click', function (e) {
        e.stopPropagation();
      });
      $navFooterTitleLogo.attr({
        'aria-expanded': 'false',
        'aria-haspopup': 'true',
        tabindex: '0',
        role: 'button'
      });
      $navFooterTitleLogo.on('keypress', function (e) {
        const code = event.which || event.keyCode || 0;
        if (code === 13 || code === 32) $(this).trigger('click');
      });
    });
  });
};

export { footer };
